import { Link } from "react-router";
import { SwiperSlide } from "swiper/react";
import ImageComponent from "../../components/core/Image/Image";
import Slider from "../../components/core/Slider/Slider";
import Text from "../../components/core/Text/Text";
import { FilterCategory } from "./Browse";
import styles from "./Timeline.module.scss";

interface Data {
  id: string;
  image: string;
  title: string;
  subTitle: string;
}

interface TimelineProps {
  data: Data[];
  category: FilterCategory;
}

const Timeline = ({ data, category }: TimelineProps) => {
  return (
    <div className={styles.wrapper}>
      <Slider
        spaceBetween={40}
        centerInsufficientSlides
        className={styles.slider}
        items={4}
        navigation
        classNamePrevButton={styles.prevButton}
        classNameNextButton={styles.nextButton}
        singleMobileItem
      >
        {data.map((item) => (
          <SwiperSlide key={item.id} className={styles.slide}>
            <Link to={`/browse/${category}/${item.id}`}>
              <ImageComponent src={item.image} className={styles.image} />
              <Text size={3} text={item.title} className={styles.title} />
              <Text size={5} text={item.subTitle} className={styles.subTitle} />
            </Link>
          </SwiperSlide>
        ))}
      </Slider>
    </div>
  );
};

export default Timeline;
